$(document).ready(function()
{
		renderRelatedGames();
});

function renderRelatedGames()
{
	var solrQuery = "LEAGUE_ID:" + leguageId + "%20AND%20(GAME_STATE:2%20OR%20GAME_STATE:3)";
	window.getSOLRData("game", solrQuery, function(data)
	{
		var itemListTmpl = Handlebars.compile($("#itemListTemplate").html());
		var sectionData = {};
		sectionData.sectionTitle = NEU.util.getLocalizedString("related_title_text");
		sectionData.itemDataType = "game";
		sectionData.itemList = window.processSectionItems(data, "game");
		sectionData.hasItemsData = sectionData.itemList.length > 0 ? true : false;
		var html = itemListTmpl(sectionData);
		$("#relatedGames").html(html);
		initSectionItemFunctions();
	});
}